module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/043-montserrat-5e8ae4a28a86a6a9c75c648d9f4fb5f7.svg";